<ag1-button
  [variant]="variant"
  (clickEvent)="toggleAccordion()"
  classOverrides="w-full {{ classOverrides }}"
>
  <!-- sequence -->
  @if (showSequence) {
    <h3 class="select-none text-xl">{{ sequence }}.</h3>
  }

  <h3
    class="cursor-pointer flex gap-2 items-center select-none {{ textClasses }}"
  >
    @if (addShowLabel) {
      <span>
        @if (!isVisible) {
          Show
        }
        @if (isVisible) {
          Hide
        }
      </span>
    }
    <span>{{ label }}</span>
    @if (labelHighlightIconPath) {
      <svg-icon
        class="content-center text-{{ labelHighlightIconColor }}-600"
        [src]="labelHighlightIconPath"
      />
    }
  </h3>

  <div class="ml-auto grid auto-cols-max grid-flow-col gap-x-2.5">
    @if (showRightLabel) {
      <span class="content-center {{ textClasses }}">{{ rightLabel }}</span>
    }
    @if (!isVisible) {
      <svg-icon
        class="content-center"
        src="/assets/icons/general/chevron-right.svg"
      />
    }
    @if (isVisible) {
      <svg-icon
        class="content-center"
        src="/assets/icons/general/chevron-down.svg"
      />
    }
  </div>
</ag1-button>
